import styled from 'styled-components';
import { NotifyIcon } from 'web-components';

export const InfoIcon = styled(NotifyIcon)`
  color: #8cb4c7 !important;
  font-size: 1.8rem !important;
  margin-left: 7px;
`;
